module.exports = __webpack_public_path__ + "img/shetab-on.32878468.png";